<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">calculate</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Custo de compra</h2>
    <span class="modal-subtitle">{{ data.descricaoItem }}</span>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn icon-mat-symbols-btn" aria-label="Fechar" (click)="fechar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content memoria-content">
  @if (formulaCard) {
  <div class="sub-section-container">
    <div class="sub-section-title">
      <mat-icon class="material-symbols-outlined">function</mat-icon>
      <span>Fórmula do preço de custo</span>
    </div>
    <app-formula-card [formula]="formulaCard" [mostrarCabecalho]="false" [mostrarVigencia]="false" [mostrarBadgeModelo]="false">
    </app-formula-card>
  </div>
  }

  <div class="sub-section-container">
    <div class="sub-section-title">
      <mat-icon class="material-symbols-outlined">list_alt</mat-icon>
      <span>Valores utilizados</span>
    </div>
    <div class="valores-utilizados">
      @for (valor of valoresPrecoCusto; track valor.chave) {
      <div class="valor-utilizado">
        <span class="valor-utilizado-descricao">
          {{ valor.descricao }}
          <span class="valor-utilizado-chave">{{ '{' + valor.chave + '}' }}</span>
        </span>
        <span class="valor-utilizado-valor">
          {{ valor.isAplicavel ? (valor.valor || 0 | abnt: 'quantidade': 4) : 'Não aplicável' }}
        </span>
      </div>
      }
    </div>

    @if (valoresImpostosRecuperaveis.length > 0) {
    <p class="sub-section-sub-title">Impostos recuperáveis considerados</p>
    <div class="valores-utilizados">
      @for (valor of valoresImpostosRecuperaveis; track valor.chave) {
      <div class="valor-utilizado">
        <span class="valor-utilizado-descricao">
          {{ valor.descricao }}
          <span class="valor-utilizado-chave">{{ '{' + valor.chave + '}' }}</span>
        </span>
        <span class="valor-utilizado-valor">
          {{ valor.isAplicavel ? (valor.valor || 0 | abnt: 'preco': 2) : 'Não aplicável' }}
        </span>
      </div>
      }
    </div>
    }

    @if (data.memoriaPrecoCusto) {
    <div class="resultado-memoria">
      <div>
        <span class="resultado-rotulo">Resultado calculado</span>
        <span class="resultado-valor">{{ data.memoriaPrecoCusto.valorBruto || 0 | abnt: 'quantidade': 6 }}</span>
      </div>
      <div>
        <span class="resultado-rotulo">Custo unitário</span>
        <span class="resultado-valor resultado-destaque">{{ data.memoriaPrecoCusto.valorArredondado || 0 | abnt: 'preco': 2 }}</span>
        <span class="resultado-nota">{{ descricaoArredondamento }}</span>
      </div>
    </div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-footer">
  <button mat-stroked-button type="button" class="btn-secondary" (click)="fechar()">Fechar</button>
</mat-dialog-actions>
